<template>
	<div class="slider-order" id="order">
		<div>
			<h2 class="title center mb-2">APP DE PEDIDOS</h2>
			<h3 class="center mb-5 subtitle">TUS DISTRIBUIDORES, TUS ALIADOS CON <span class="text-green">MI BODEGA</span></h3>
		</div>
		<v-layout wrap>
			<v-flex class="w-50">
				<div class="wrapper-text mb-5">
					<p class="text-green bold center">¡Ahora tus distribuidores serán tus socios de negocio!</p>
					<p class="center">Haz crecer tu empresa, dales tu propia App a tus clientes y distribuidores, 
						conviértelos en tus socios de negocio, tu App, tu marca. </p>
				</div>
				<div class="wrapper-text">
					<p class="text-green bold center">¡Planea, supervisa y analiza tus ventas en ruta desde donde te encuentres!</p>
					<p class="center">Te ofrecemos una potente aplicación android que te permite vender 
						con o sin internet y gestionar tu punto de venta.</p>
				</div>
				<div class="center">
					<a class="btn-section bold" href="#footer">SOLICITA MÁS INFORMACIÓN</a>
				</div>
			</v-flex>
			<v-flex class="w-50">
				<div class="wrapper-slider-order">
					<slider animation="fade" :speed="2000" height="100%">
						<slider-item>
							<div class="center">
								<img src="" 
									alt="slide1-min"
									class="img-slider"
								>
							</div>
						</slider-item>
						<slider-item>
							<div class="center">
								<img src="" 
									alt="slider-1"
									class="img-slider"
								>
							</div>
						</slider-item>
						<slider-item>
							<div class="center">
								<img src="" 
									alt="slider-1"
									class="img-slider"
								>
							</div>
						</slider-item>
						<slider-item>
							<div class="center">
								<img src="" 
									alt="slider-1"
									class="img-slider"
								>
							</div>
						</slider-item>
					</slider>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>

function data() {
	return {
		swiperOptions: {
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 10500,
				disableOnInteraction: true,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		},
	};
}
export default {
	name: 'slider-order',
	data,
};
</script>
<style lang="scss">
	.slider-order {
		background: map-get($colors, back-gray-l);
		padding: 80px 7%;
		font-family: font(lato-regular);

		.title {
			color: map-get($colors, green-dark);
			font-size: 32px !important;
			font-weight: 600;
		}

		.center {
			text-align: center;
		}

		.text-green {
			color: map-get($colors, title-green);
		}

		.subtitle {
			font-size: 20px !important;
		}

		.bold {
			font-weight: 600;
		}

		.wrapper-text {
			background-color: map-get($colors, white);
			border-radius: 9px;
			box-shadow: 0 2px 19px 0 rgba(234, 234, 234, 0.5);
			padding: 47px 32px;
		}

		.btn-section {
			background: map-get($colors, green-link);
			border-radius: 9px;
			color: map-get($colors, white);
			display: inline-block;
			margin: 20px 0 20px 0;
			padding: 10px 46px;
			text-decoration: none;
		}

		.img-slider {
			height: 480px;
		}

		.wrapper-slider-order {
			height: 100%;
			position: relative;

			@media (max-width: 936px) {
				height: 480px;
			}
		}

		.w-50 {
			width: 50%;

			@media (max-width: 936px) {
				width: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/slider-order.vue